import { render, staticRenderFns } from "./TheAdminAside.vue?vue&type=template&id=376b669e&scoped=true&"
import script from "./TheAdminAside.vue?vue&type=script&lang=js&"
export * from "./TheAdminAside.vue?vue&type=script&lang=js&"
import style0 from "./TheAdminAside.vue?vue&type=style&index=0&id=376b669e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b669e",
  null
  
)

export default component.exports